/* Happy Yak storefront: multi-pair offer panel (Change Log 0010, "Fall Trail Reset").
   Rendered by snippets/mp-tier-offer.liquid inside the generic product page (mockup-storefront-product-main).
   Keeps the tier highlight, the quantity stepper and the add-to-cart total in step. Display only:
   the money comes off through the automatic discounts in Admin > Discounts. */
(function () {
  document.querySelectorAll('[data-mp]').forEach(init);

  function formatMoney(cents, format) {
    var amount = cents / 100;
    var fmt = format || '${{amount}}';
    function withCommas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas(amount.toFixed(2)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(String(Math.round(amount))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
  }

  function init(root) {
    var panel = root.querySelector('[data-mp-offer]');
    if (!panel) return;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var sizes = (panel.dataset.offerSizes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var tiers = Array.prototype.slice.call(panel.querySelectorAll('[data-offer-tier]'));
    var price = parseInt(panel.dataset.offerPrice, 10) || 0;
    var qtyInput = root.querySelector('input[name="quantity"]');
    var addBtn = root.querySelector('[data-mp-add]');
    var note = panel.querySelector('[data-offer-note]');
    var warn = panel.querySelector('[data-offer-warn]');
    var baseNote = note ? note.dataset.offerBase || note.textContent : '';
    var eligible = !panel.hasAttribute('data-ineligible');
    var available = addBtn ? !addBtn.disabled : true;

    function money(c) { return formatMoney(c, moneyFormat); }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function pctFor(q) {
      var best = 0;
      tiers.forEach(function (t) {
        var min = parseInt(t.dataset.offerTier, 10), p = parseInt(t.dataset.offerPct, 10) || 0;
        if (q >= min && p > best) best = p;
      });
      return best;
    }

    function update() {
      var q = qty();
      var pct = eligible ? pctFor(q) : 0;
      tiers.forEach(function (t) {
        var p = parseInt(t.dataset.offerPct, 10) || 0;
        var min = parseInt(t.dataset.offerTier, 10);
        var active = eligible && (p === pct) && (p > 0 || min === 1);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
        var each = Math.floor(price * (100 - p) / 100);
        var el = t.querySelector('[data-offer-each]');
        if (el) el.textContent = money(each) + (min > 1 ? ' each' : '');
      });
      var total = price * q;
      var off = Math.round(total * pct / 100);
      var finalTotal = total - off;
      if (addBtn && available) {
        addBtn.innerHTML = (q > 1 ? 'Add ' + q + ' pairs' : 'Add to cart') + ' · <span data-mp-btn-price>' + money(finalTotal) + '</span>';
      }
      if (note) {
        note.textContent = pct > 0
          ? q + ' pairs for ' + money(finalTotal) + ' at checkout. You save ' + money(off) + '. Comes off automatically, no code needed.'
          : baseNote;
      }
      panel.toggleAttribute('data-ineligible', !eligible);
      if (warn) warn.hidden = eligible;
    }

    // Tier buttons set the quantity.
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = parseInt(t.dataset.offerTier, 10) || 1;
        update();
        qtyInput.dispatchEvent(new Event('offer:qty'));
      });
    });

    // Quantity stepper and typed changes. The stepper's own handler (mockup-product.js) runs first.
    root.querySelectorAll('[data-mp-qty]').forEach(function (b) { b.addEventListener('click', update); });
    if (qtyInput) {
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
    }

    // Variant changes: new price, new eligibility, and mockup-product.js has just rewritten the button.
    root.addEventListener('mp:variant', function (e) {
      var v = e.detail || {};
      price = v.price || price;
      available = !!v.available;
      var opts = v.options || [];
      eligible = sizes.length === 0 || opts.some(function (o) { return sizes.indexOf(o) !== -1; });
      if (warn && !eligible) {
        var size = (v.title || '').split(' / ')[0] || opts[0] || 'This size';
        warn.textContent = size + " isn't part of this offer. It's on " + (warn.dataset.offerSizesHuman || sizes.join(' & ')) + ' only.';
      }
      update();
    });

    update();
  }
})();
